import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const textColor = '#2A4494';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    marginTop: 20
  },
  headerContainer: {
    flexDirection: 'column',
    marginTop: 10
  },
  label: {
    paddingBottom: 5,
    fontSize: 12,
    color: textColor,
    fontWeight: 'bold'
  },
  methodItem: {
    flexDirection: 'row',
    marginBottom: 3,
    fontSize: 10
  },
  methodName: {
    fontWeight: 'bold',
    marginRight: 5
  },
  methodLink: {
    color: '#198FCC',
    textDecoration: 'none'
  }
});

const InvoicePaymentMethods = ({ paymentMethods, labelText = '' }) => {
  if (!paymentMethods || paymentMethods.length === 0) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.label}>{labelText}</Text>
      <View style={styles.headerContainer}>
        {paymentMethods.map((method, index) => (
          <View key={`payment-method-${index}`} style={styles.methodItem}>
            <Text style={styles.methodName}>{method.name}:</Text>
            <Text style={styles.methodLink}>{method.link}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default InvoicePaymentMethods;
